import Vue from 'vue'
import cancellationUrlWithError from '~utils/psp-cancellation'

export default Vue.extend({
  data() {
    return {
      connectionLost: false,
    }
  },
  computed: {
    backToLHLink() {
      return cancellationUrlWithError(this.$store.state.redemptions.redemption?.cancellationUrl, 'SESSION_TIMEOUT')
    },
  },
  created() {
    window.addEventListener('online', () => {
      this.connectionLost = false
    })

    window.addEventListener('offline', () => {
      this.connectionLost = true
    })
  },
})
